import { RejectedInfluencers, SelectedInfluencers, UserProposalContextType } from '@anytag/shared-organisms';
import {
  namedOperations,
  useSnackbarHelper,
  ProposalJobDescriptionBreakDownMode,
  useUpdateUserProposalBreakdownModeMutation
} from '@anytag/graphql';

export const ProposeInfluencersList = ({ userProposal }: Pick<UserProposalContextType, 'userProposal'>) => {
  const { enqueueSnackbar } = useSnackbarHelper();

  const { callUpdateUserProposalBreakdownMode, loading: updatingBreakDownMode } =
    useUpdateUserProposalBreakdownModeMutation({
      refetchQueries: [namedOperations.Query.UserProposal],
      awaitRefetchQueries: true
    });

  const jdMode = userProposal?.jdMode;

  const handleJdModeChange = async (mode: ProposalJobDescriptionBreakDownMode) => {
    try {
      await callUpdateUserProposalBreakdownMode({
        variables: { input: { jdMode: mode } }
      });
    } catch (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
    }
  };

  return (
    <>
      <SelectedInfluencers
        loading={updatingBreakDownMode}
        currency={userProposal?.currency}
        tableModeProps={{
          jdMode,
          onEditJdMode: handleJdModeChange
        }}
      />

      <RejectedInfluencers jdMode={jdMode} />
    </>
  );
};
